import coreAPIInstance from "./coreApiInstance";

export const thumbnailTemplateAPIs = {
  createThumbnailTemplate: ({ payload }) => coreAPIInstance.post("/api/v1/template", payload),
  getThumbnailTemplates: ({ payload }) => coreAPIInstance.post("/api/v1/get.templates", payload),
  getThumbnailTemplateGroupedByDate: ({ payload }) => coreAPIInstance.post("/api/v1/get.datewise.templates", payload),
  getThumbnailTemplateById: ({ id, payload }) => coreAPIInstance.get(`/api/v1/get.template/${id}`, payload),
  updateThumbnailTemplateById: ({ id, payload }) => coreAPIInstance.put(`/api/v1/update.template/${id}`, payload),
  deleteThumbnailTemplateById: ({ id, payload }) => coreAPIInstance.delete(`/api/v1/delete.template/${id}`, payload),
  createThumbnailTemplatePreset: ({ payload }) => coreAPIInstance.post("/api/v1/create.preset", payload),
  getThumbnailTemplatePresets: ({ payload }) => coreAPIInstance.post("/api/v1/get.presets", payload),
  deleteThumbnailTemplatePreset: ({ id, payload }) => coreAPIInstance.delete(`/api/v1/delete.preset/${id}`, payload),
  createThumbnailTemplateImage: ({ payload }) => coreAPIInstance.post("/api/v1/create.image", payload),
  getThumbnailTemplateImages: ({ payload }) => coreAPIInstance.post("/api/v1/get.images", payload),
  deleteThumbnailTemplateImage: ({ id, payload }) => coreAPIInstance.delete(`/api/v1/delete.image/${id}`, payload),
  getThumbnailTemplateByClipId: ({ id, payload }) =>
    coreAPIInstance.get(`/api/v1/get.template.byClipId/${id}`, payload),
};
